import { useQuery } from '@tanstack/react-query'
import { getHealth } from '@/api/client'

/**
 * F1 scaffold screen: proves the web app reaches the API end to end.
 * Replaced by the real dashboard in F5.
 */
export function SystemStatus() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['health'],
    queryFn: getHealth,
    refetchInterval: 10_000,
  })

  return (
    <main className="mx-auto flex min-h-full max-w-2xl flex-col justify-center gap-6 p-8">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">FMCG ERP Suite</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Foundation scaffold &mdash; milestone F1
        </p>
      </header>

      <section className="rounded-lg border border-slate-200 p-5 dark:border-slate-800">
        <h2 className="mb-3 text-sm font-medium uppercase tracking-wide text-slate-500">
          API connection
        </h2>

        {isLoading && <p className="text-slate-500">Checking&hellip;</p>}

        {error && (
          <p className="text-danger">
            Cannot reach the API. Is it running? <code>docker compose up api</code>
          </p>
        )}

        {data && (
          <dl className="grid grid-cols-2 gap-y-2 text-sm">
            <dt className="text-slate-500">Status</dt>
            <dd className="font-medium text-success">{data.status}</dd>
            <dt className="text-slate-500">Service</dt>
            <dd className="font-medium">{data.service}</dd>
            <dt className="text-slate-500">Version</dt>
            <dd className="font-medium">{data.version}</dd>
            <dt className="text-slate-500">Environment</dt>
            <dd className="font-medium">{data.environment}</dd>
          </dl>
        )}
      </section>
    </main>
  )
}
